export default __webpack_public_path__ + "static/media/Sycamore Icons-03.f2cc25d0.svg";